import { render, staticRenderFns } from "./property-setting-form-page.vue?vue&type=template&id=24f77ad3&"
import script from "./property-setting-form-page.vue?vue&type=script&lang=js&"
export * from "./property-setting-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports